import clsx from "clsx";
import React from "react";
import { Loader } from "../../../icons";

export const Button = ({
  type = "primary",
  variant = "contained",
  children,
  size = "sm",
  bgColor = "primary",
  loading = false,
  disabled = false,
  className,
  ...rest
}) => {
  return (
    <button
      className={clsx(
        `flex w-full rounded-xl justify-center items-center text-white font-semibold text-base cursor-pointer`,
        variant === "contained" &&
          `bg-${bgColor} hover:bg-textGray enabled:hover:border-none hover:text-white`,
        variant === "secondary" &&
          `bg-textGray enabled:hover:bg-primary enabled:hover:border-none hover:text-white`,
        variant === "outlined" &&
          `bg-transparent border border-primary text-primary enabled:hover:bg-primary enabled:hover:text-white`,
        disabled &&
          "opacity-50 text-white cursor-not-allowed hover:text-white hover:border-none",
        size === "sm" && "p-2",
        size === "md" && "p-3",
        size === "lg" && "p-5",
        className
      )}
      disabled={disabled}
      {...rest}
    >
      {!loading ? children : <Loader height={20} width={20} fill="#fff" />}
    </button>
  );
};
